import { Box, Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AppCache from "../../Helper/Common/AppCache";
import { useBaseEntityInfo } from "../../Hooks/usePagesContent";
import { getPingStatusDefinitionRows } from "./pingStatusDefinitions";

export const PingStatusDefinitionRow = ({ label, description, icon }) => (
  <Box sx={{ display: "flex", gap: "6px" }}>
    <Box sx={{ mt: "2px", flexShrink: 0 }}>{icon}</Box>
    <Typography sx={{ fontSize: "11px", lineHeight: "16px", color: "#fff" }}>
      <Box component="span" sx={{ fontWeight: 600 }}>{label}: </Box>{description}
    </Typography>
  </Box>
);

// Tooltip body explaining online/offline. Pass status to show only that row,
// headline for a line above it (e.g. "Offline since 2 hours"), and entityLabel
// when the dot belongs to a sub-entity such as a pack rather than the base entity.
const PingStatusDefinition = ({ status, headline, entityLabel }) => {
  const { baseEntityTypeLable } = useBaseEntityInfo();
  const rows = getPingStatusDefinitionRows({
    entityLabel: entityLabel || baseEntityTypeLable,
    threshold: AppCache.getItem("pingStatusThreshold"),
    status,
  });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {headline && (
        <Typography sx={{ fontSize: "12px", lineHeight: "16px", fontWeight: 600, color: "#fff" }}>
          {headline}
        </Typography>
      )}
      {rows.map(({ key, label, description, color }) => (
        <PingStatusDefinitionRow
          key={key}
          label={label}
          description={description}
          icon={<FiberManualRecordIcon sx={{ color, width: 14, height: 14 }} />}
        />
      ))}
    </Box>
  );
};

export default PingStatusDefinition;
